// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77b8931d","453":"ce761ae4","455":"93e3a8a9","977":"ea8bc86b"}[chunkId] + ".chunk.js";
};